<template>
  <v-tabs v-model="selectedMenuItemIndex" centered grow ref="tabs">
    <v-tab
      class="px-1 mx-0 type-tabs"
      v-for="filter in menuItems"
      :key="filter"
      :disabled="disabled"
    >
      {{ filter }}
    </v-tab>

    <v-menu v-if="moreMenuItems.length" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          class="align-self-center mr-4 uppercase-text"
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
        >
          more
          <v-icon right>
            mdi-menu-down
          </v-icon>
        </v-btn>
      </template>

      <v-list class="uppercase-text">
        <v-list-item
          v-for="item in moreMenuItems"
          :key="item"
          @click="addItem(item)"
        >
          {{ item }}
        </v-list-item>
      </v-list>
    </v-menu>
  </v-tabs>
</template>
<script>
import { compact } from "lodash";

const EMITTED_ACTIONS = {
  SELECTED_MENU: "selected-menu",
};

export default {
  name: "OverflowMenu",
  components: {},
  props: {
    orderedMenuItems: {
      type: Array,
    },
    menuItemsCount: {
      type: Number,
    },
    defaultSelectedMenuItem: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedMenuItemIndex: this.orderedMenuItems.findIndex(
        (o) => o === this.defaultSelectedMenuItem
      ),
      menuItems: this.orderedMenuItems.slice(
        0,
        this.orderedMenuItems.length > this.menuItemsCount
          ? this.menuItemsCount
          : this.orderedMenuItems.length
      ),
      moreMenuItems: this.orderedMenuItems.slice(
        this.menuItemsCount,
        this.orderedMenuItems.length
      ),
    };
  },
  methods: {
    addItem(item) {
      // Always rotate the last visible element
      const removed = this.menuItems.splice(this.menuItems.length - 1, 1);
      this.menuItems.push(
        ...this.moreMenuItems.splice(this.moreMenuItems.indexOf(item), 1)
      );
      this.moreMenuItems.push(...removed);

      const menuItemsOrdered = this.orderedMenuItems.map((fo) =>
        this.menuItems.find((m) => m === fo)
      );
      this.menuItems = compact(menuItemsOrdered);

      const moreMenuItemsOrdered = this.orderedMenuItems.map((fo) =>
        this.moreMenuItems.find((m) => m === fo)
      );
      this.moreMenuItems = compact(moreMenuItemsOrdered);

      this.$nextTick(() => {
        this.selectedMenuItemIndex = this.menuItems.findIndex((m) => m == item);
        this.$emit(EMITTED_ACTIONS.SELECTED_MENU, {
          item: item,
          index: this.selectedMenuItemIndex,
          currentMenu: this.menuItems,
        });
      });
    },
  },
  watch: {
    selectedMenuItemIndex: {
      async handler() {
        this.$emit(EMITTED_ACTIONS.SELECTED_MENU, {
          item: this.menuItems[this.selectedMenuItemIndex],
          index: this.selectedMenuItemIndex,
          currentMenu: this.menuItems,
        });
      },
      deep: true,
    },
    defaultSelectedMenuItem: {
      async handler(val) {
        this.selectedMenuItemIndex = this.menuItems.findIndex((m) => m === val);
      },
    },
  },
};
</script>

<style scoped>
.type-tabs {
  font-size: smaller;
}

.uppercase-text {
  font-size: smaller;
  text-transform: uppercase;
}
</style>
